import {NgModule} from "@angular/core";
import {HomeScreenComponent} from "./homescreen.component";
import {HomescreenRoutingModule} from "./homescreen-routing.module";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

import {MatToolbarModule} from "@angular/material/toolbar";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatGridListModule} from "@angular/material/grid-list";
import {DialogEditFavoritesComponent} from "./dialog-edit-favorites/dialog-edit-favorites.component";
import {MatDialogModule} from "@angular/material/dialog";
import {DragDropModule} from "@angular/cdk/drag-drop";

import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {RouterModule} from "@angular/router";
import {ReportScreenRoutes} from "../reports-screen/reports-screen.routes";
import {MepPopoverDirective} from "src/app/shared/mep-popover/mep-popover.directive";

import {SkillgroupModule} from "../../shared/skillgroup/skillgroup.module";
import {MatCheckboxModule} from "@angular/material/checkbox";

import {MatSelectModule} from "@angular/material/select";

import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {TrafficLightMecMepComponent} from "./traffic-light-mec-mep/traffic-light-mec-mep.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MecDataComponent} from "./mec-data/mec-data.component";

import {AssignmentsNotificationDialogComponent} from "../../shared/assignments-notification-dialog/assignments-notification-dialog.component";

import {MatTableModule} from "@angular/material/table";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatSortModule} from "@angular/material/sort";

@NgModule({
	imports: [
		HomescreenRoutingModule,
		TranslateModule,
		MatToolbarModule,
		MatCardModule,
		MatIconModule,
		MatGridListModule,
		DragDropModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		CommonModule,
		RouterModule.forChild(ReportScreenRoutes),
		MepPopoverDirective,
		SkillgroupModule,
		MatDialogModule,
		MatButtonModule,
		MatTooltipModule,
		MatCardModule,
		MatCheckboxModule,
		MatSelectModule,
		MatProgressSpinnerModule,
		MatSlideToggleModule,
		MatTableModule,
		MatProgressBarModule,
		MatButtonToggleModule,
		MatSortModule,
		HomeScreenComponent,
		DialogEditFavoritesComponent,
		TrafficLightMecMepComponent,
		MecDataComponent,
		AssignmentsNotificationDialogComponent,
	],
	exports: [HomeScreenComponent],
})
export class HomescreenModule {}
